// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { hammer16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-hammer': IconHammer;
    }
}

/**
 * The icon component for the 'hammer' icon
 */
export class IconHammer extends Icon {
    public constructor() {
        super(hammer16X16);
    }
}

registerIcon('icon-hammer', IconHammer);
export const iconHammerTag = 'nimble-icon-hammer';
